// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"_L-z","smallCardRow":"aM-z","largeCardRow":"bM-z","productSearchRow":"cM-z","curatedRow":"dM-z"};